<template>
  <div v-if="sCrtType">
    <!-- <van-image
      width="100%"
      height="500px"
      src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
    /> -->
    <!-- <van-sticky :offset-top="46"> -->
    <el-container>
      <el-aside width="120px" class="HideScrollbar">
        <div style="height:1rem"></div>
        <div v-for="mt in sBKMenu.menutype" :title="mt.id" :key="mt.id">
          <MT :obj="mt" />
        </div>
      </el-aside>
      <el-main class="HideScrollbar">
        <div v-html="sCrtType.text" />
        <Line2 n="2" :ordertmp="ordertmp" @click="cmdMI" />
        <!-- {{ sTypeNo }} -->
        <!-- {{ list }} -->
      </el-main>
    </el-container>
    <!-- </van-sticky> -->
    <!-- <van-tabs
      scrollspy
      sticky
      :offset-top="45"
      title-active-color="black"
      v-bind:color="sGetConfig('color3')"
      class="HideScrollbar"
    >
      <van-tab v-for="mt in bkmenu.menutype" :title="mt.id" :key="mt.id">
        <center>
          <div style="height: 3rem; line-height: 3rem">
            <h4>{{ mt.id }}</h4>
          </div>
        </center>
        <Line2 n="2" :list="getList(mt)" :ordertmp="ordertmp" @click="cmdMI" />

        <div style="height: 0.5rem; background-color: #eee"></div>
      </van-tab>
    </van-tabs> -->
  </div>
</template>

<style scoped>
.el-container,
.el-aside {
  z-index: 1;
}
.van-image {
  /* height: 100px; */
  width: 6rem;
  height: 6rem;
  border-radius: 3rem;
}
.van-tag {
  line-height: 1rem;
  font-size: 1rem;
  border-radius: 2rem;
}
.remark {
  color: grey;
  margin: 0.3rem 0 0.3rem 0;
}
h3 {
  padding-left: 0.5rem;
}
.el-aside {
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  padding-bottom: 6rem;
  height: 90vh;
}
.el-main {
  position: fixed;
  width: 100%;
}
.el-main {
  /* padding: 1rem;
  padding-top: 1rem; */
  height: 90vh;
  /* padding-bottom: 6rem; */
  padding-left: 120px;
  padding-right: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>

<script>
import MT from "./MT.vue";
// import MI from "./MI.vue";
// import Line1 from "./Line1.vue";
import Line2 from "./Line2.vue";
export default {
  components: {
    // Line1,
    Line2,
    MT,
    // MI
  },
  mounted() {
    console.log("menulr.mounted", this.$store.state.sBKMenu);
    console.log("menulr.mounted", this.sCrtType);

    // var menutype = this.sBKMenu.menutype;
    // console.log(menutype);
    // if (menutype != undefined) {
    // if (menutype.length > 0) {
    //   this.getList(menutype);
    // }
    // }
  },
  props: {
    bkmenu: Object,
    ordertmp: Array,
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    // cmdMT(menutype) {
    // var mt = this.gGetTypeOptions(menutype);
    // mt = menutype[0];

    // this.$store.commit("setCrtType", mt);
    // var list = [];
    // menutype.options.forEach((mt) => {
    //   // console.log(mt);
    //   var row = this.findItem(mt);
    //   if (row) {
    //     list.push(row);
    //   }
    // });
    // this.list = list;
    // return list;
    // },
    getItemQty(item) {
      var array = this.ordertmp.filter(
        (r) => r.TypeNo == item.TypeNo && r.ItemName == item.ItemName
      );
      return this.gSum(array, "Qty");
    },
    getTypeQty(obj) {
      var options = obj.options;
      if (options == undefined) {
        return 0;
      }
      if (options.length == 0) {
        return 0;
      }
      var sum = 0;
      options.forEach((r) => {
        sum += this.getItemQty(r);
      });
      return sum;
    },
    cmdMI(obj) {
      this.$emit("click", obj);
    },
    findItem(obj) {
      var mi = this.bkmenu.menuitem.find(
        (r) => (r.TypeNo == obj.TypeNo) & (r.ItemName == obj.ItemName)
      );
      if (!mi) {
        return null;
      }

      var find = this.bkmenu.extitem.find((r) => r.itemname == obj.ItemName);
      if (find) {
        mi.ImgFile = find.imgfile;
        mi.Remark = find.desc;
        mi.DispName = find.dispname;
        mi.Discount = find.discount;
      }
      if (mi.DispName == "" || mi.DispName == undefined) {
        mi.DispName = obj.ItemName;
      }
      return mi;
    },
  },
};
</script>
